import { useHeyApi } from "@platform/api";
import { useQuery } from "@tanstack/react-query";

export interface PlanOption {
  id: string;
  coverageType: string;
  size: number;
  label: string;
  policyPeriod?: string;
  nickname?: string;
}

interface PlanOptionsResponse {
  planOptions: PlanOption[];
}

interface UsePlanOptionsOptions {
  rfpId: string | undefined;
  enabled?: boolean;
}

interface UsePlanOptionsResult {
  planOptions: PlanOption[];
  isLoading: boolean;
  error: Error | null;
}

export const usePlanOptions = ({
  rfpId,
  enabled = true,
}: UsePlanOptionsOptions): UsePlanOptionsResult => {
  const { centroPortalClient } = useHeyApi();

  const { data, isLoading, error } = useQuery({
    queryKey: ["quotes-plan-options", rfpId],
    enabled: enabled && !!rfpId,
    staleTime: 5 * 60 * 1000,
    queryFn: async () => {
      if (!rfpId) {
        return { planOptions: [] } satisfies PlanOptionsResponse;
      }

      const response = await centroPortalClient.get<
        PlanOptionsResponse,
        unknown,
        true
      >({
        url: `/rfps/${encodeURIComponent(rfpId)}/plan-options`,
        responseType: "json",
        throwOnError: true,
      });

      return response.data;
    },
  });

  return {
    planOptions: data?.planOptions ?? [],
    isLoading,
    error: error instanceof Error ? error : null,
  };
};
